import script from "./LayerLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./LayerLegend.vue?vue&type=script&lang=ts&setup=true"

import "./LayerLegend.vue?vue&type=style&index=0&id=6ac3165e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac3165e"]])

export default __exports__